// FIXME: currently just a dumb placeholder

export class Map {
    constructor(node, props) {
        this.node = node;
        this.props = props;
    }

    static featureToPopup(feature) {
        return feature.properties && feature.properties.popup;
    }

    static featureToStyle(feature) {
        console.log(feature);

        return feature.properties && feature.properties.style;
    }
}
